export default {
      id: "video-full-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.svg#video-full",
      toString: function () {
        return this.url;
      }
    }